import restService from "../rest-service/RestService";
import { IEditDTO, IReferenceDTO, ISummaryDTO, ISummaryUsageDTO } from "./Models";


const NotificationListDataService = {

    getNotificationList: async function (
        groupID: number,
        organizationID: number,
        notificationListID: number,
        signal?: AbortSignal
    ): Promise<IEditDTO> {

        if (notificationListID > 0) {

            const path = `/groups/${groupID}/organizations/${organizationID}/notificationlists/${notificationListID}`;
            const response = await restService.get<IEditDTO>(path, signal);
            return response.data;
        } else {
            return {
                id: -1,
                name: '',
                recipients: []
            }
        }
    },

    getReferenceData: async function (
        groupID: number,
        organizationID: number,
        signal?: AbortSignal
    ): Promise<IReferenceDTO> {
        const path = `/groups/${groupID}/organizations/${organizationID}/notificationlists/referenceData`;
        const response = await restService.get<IReferenceDTO>(path, signal);
        return response.data;
    },

    saveNotificationList: async function(
        groupID: number,
        organizationID: number,
        model: IEditDTO): Promise<IEditDTO> {

        const path = `/groups/${groupID}/organizations/${organizationID}/notificationlists`;
        const response = await restService.post<IEditDTO, IEditDTO>(path, model);
        return response.data;
    },

    getNotificationLists: async function(
        groupID: number,
        organizationID: number,
        signal?: AbortSignal): Promise<ISummaryDTO[]> {

        const path = `/groups/${groupID}/organizations/${organizationID}/notificationlists`;
        const response = await restService.get<ISummaryDTO[]>(path, signal);
        return response.data;
    },
    getNotificationListUsage: async function(
        groupID: number,
        organizationID: number,
        notificationListID: number,
        signal?: AbortSignal): Promise<ISummaryUsageDTO[]> {

            const path = `/groups/${groupID}/organizations/${organizationID}/notificationlists/${notificationListID}/usage`;
            const response = await restService.get<ISummaryUsageDTO[]>(path, signal);
            return response.data;
    },
    deleteNotificationList: async function(
        groupID: number,
        organizationID: number,
        notificationListID: number): Promise<void> {

            const path = `/groups/${groupID}/organizations/${organizationID}/notificationlists/${notificationListID}`;
            await restService.delete(path);
    }
    
   



// public getReferenceData(groupId: number, organizationId: number, forceRefresh: boolean = false)
// : Services.RestPromise<NotificationListModels.IReferenceDTO> {

// // Determine if we need to make a request
// const newParams = [groupId, organizationId].join(";");

// if (forceRefresh || (newParams !== this._getReferenceData_Previous_Params)) {

//     // Store for next time
//     this._getReferenceData_Previous_Params = newParams;

//     // "~/groups/{groupID:int}/organizations/{organizationID:int}/notificationLists/referenceData"
//     const path = [
//         "groups",
//         groupId,
//         "organizations",
//         organizationId,
//         "notificationlists",
//         "referenceData"
//     ].join("/");

//     // Retrieve reference data
//     return this._restService
//         .get<NotificationListModels.IReferenceDTO>(path)
//         .then(data => {

//             // Store for next time
//             this._getReferenceData_Previous_Results = data.entity;

//             return data.entity;

//         });
// } else {
//     // No need to make a server request; return previously stored results
//     return When.resolve(this._getReferenceData_Previous_Results);

// }
// }







}


export default NotificationListDataService;

// public getNotificationList(groupId: number, organizationId: number, notificationListId: number)
// : Services.RestPromise<NotificationListModels.IEditDTO> {

// if ((notificationListId !== null) &&
//     (notificationListId > 0)) {

//     // "~/groups/{groupID:int}/organizations/{organizationID:int}/notificationlists/{notificationListID:int}"
//     const path = [
//         "groups",
//         groupId,
//         "organizations",
//         organizationId,
//         "notificationlists",
//         notificationListId
//     ].join("/");

//     return this._restService
//         .get<NotificationListModels.IEditDTO>(path)
//         .then(data => {

//             return data.entity;

//         });
// } else {

//     // Create an empty/new notification list
//     const notificationList = new NotificationListModels.EditModel(null, null);

//     return When.resolve(notificationList.toDataTransferObject());

// }
// }













// ///////////////////////////////////////////////////////////////////////////////////////////////
// // getNotificationList - implementation, supporting fields and methods
// ///////////////////////////////////////////////////////////////////////////////////////////////

// public getNotificationList(groupId: number, organizationId: number, notificationListId: number)
// : Services.RestPromise<NotificationListModels.IEditDTO> {

// if ((notificationListId !== null) &&
//     (notificationListId > 0)) {

//     // "~/groups/{groupID:int}/organizations/{organizationID:int}/notificationlists/{notificationListID:int}"
//     const path = [
//         "groups",
//         groupId,
//         "organizations",
//         organizationId,
//         "notificationlists",
//         notificationListId
//     ].join("/");

//     return this._restService
//         .get<NotificationListModels.IEditDTO>(path)
//         .then(data => {

//             return data.entity;

//         });
// } else {

//     // Create an empty/new notification list
//     const notificationList = new NotificationListModels.EditModel(null, null);

//     return When.resolve(notificationList.toDataTransferObject());

// }
// }



// ///////////////////////////////////////////////////////////////////////////////////////////////
// // getNotificationLists - implementation, supporting fields and methods
// ///////////////////////////////////////////////////////////////////////////////////////////////

// public getNotificationLists(groupId: number, organizationId: number)
// : Services.RestPromise<Array<NotificationListModels.ISummaryDTO>> {

// // "~/groups/{groupID:int}/organizations/{organizationID:int}/notificationlists"
// const path = [
//     "groups",
//     groupId,
//     "organizations",
//     organizationId,
//     "notificationlists"
// ].join("/");

// return this._restService
//     .get<Array<NotificationListModels.ISummaryDTO>>(path)
//     .then(data => {

//         return data.entity;

//     });
// }



// ///////////////////////////////////////////////////////////////////////////////////////////////
// // getNotificationListUsage - implementation, supporting fields and methods
// ///////////////////////////////////////////////////////////////////////////////////////////////

// public getNotificationListUsage(groupId: number, organizationId: number, notificationListId: number)
// : Services.RestPromise<Array<NotificationListModels.ISummaryUsageDTO>> {

// // "~/groups/{groupID:int}/organizations/{organizationID:int}/notificationlists/{notificationListID:int}/usage"
// const path = [
//     "groups",
//     groupId,
//     "organizations",
//     organizationId,
//     "notificationlists",
//     notificationListId,
//     "usage"
// ].join("/");

// return this._restService
//     .get<Array<NotificationListModels.ISummaryUsageDTO>>(path)
//     .then(data => {

//         return data.entity;

//     });
// }



// ///////////////////////////////////////////////////////////////////////////////////////////////
// // getReferenceData - implementation, supporting fields and methods
// ///////////////////////////////////////////////////////////////////////////////////////////////

// public getReferenceData(groupId: number, organizationId: number, forceRefresh: boolean = false)
// : Services.RestPromise<NotificationListModels.IReferenceDTO> {

// // Determine if we need to make a request
// const newParams = [groupId, organizationId].join(";");

// if (forceRefresh || (newParams !== this._getReferenceData_Previous_Params)) {

//     // Store for next time
//     this._getReferenceData_Previous_Params = newParams;

//     // "~/groups/{groupID:int}/organizations/{organizationID:int}/notificationLists/referenceData"
//     const path = [
//         "groups",
//         groupId,
//         "organizations",
//         organizationId,
//         "notificationlists",
//         "referenceData"
//     ].join("/");

//     // Retrieve reference data
//     return this._restService
//         .get<NotificationListModels.IReferenceDTO>(path)
//         .then(data => {

//             // Store for next time
//             this._getReferenceData_Previous_Results = data.entity;

//             return data.entity;

//         });
// } else {
//     // No need to make a server request; return previously stored results
//     return When.resolve(this._getReferenceData_Previous_Results);

// }
// }


// // Fields used to determine if we need to make a request
// private _getReferenceData_Previous_Params: string = null;
// private _getReferenceData_Previous_Results: NotificationListModels.IReferenceDTO = null;



// ///////////////////////////////////////////////////////////////////////////////////////////////
// // saveNotificationList - implementation, supporting fields and methods
// ///////////////////////////////////////////////////////////////////////////////////////////////

// public saveNotificationList(groupId: number, organizationId: number, notificationList: NotificationListModels.IEditDTO)
// : Services.RestPromise<NotificationListModels.IEditDTO> {

// // "~/groups/{groupID:int}/organizations/{organizationID:int}/notificationlists"
// const path = [
//     "groups",
//     groupId,
//     "organizations",
//     organizationId,
//     "notificationlists"
// ].join("/");

// return this._restService
//     .post<NotificationListModels.IEditDTO, NotificationListModels.IEditDTO>(path, notificationList)
//     .then(data => {

//         return data.entity;

//     });
// }



// ///////////////////////////////////////////////////////////////////////////////////////////////
// // updateRecipient - implementation, supporting fields and methods
// ///////////////////////////////////////////////////////////////////////////////////////////////

// public updateRecipient(groupId: number, recipient: Models.IRecipientModel)
// : Services.RestPromise<any> {

// // "~/groups/{groupID:int}/recipients"
// const path = [
//     "groups",
//     groupId,
//     "recipients"
// ].join("/");

// return this._restService
//     .put<any, Models.IRecipientModel>(path, recipient)
//     .then(data => {

//         return data.entity;

//     });
// }
